export default {"src":"/_next/static/media/moved-badge.cd1c18d0.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};